// extracted by mini-css-extract-plugin
export default {"background":"Menu_background__OnnZ-","container":"Menu_container__9tDYw","course":"Menu_course__2Jb3p","divider":"Menu_divider__NZZ4g"};